<script lang="ts" setup>
import type { ButtonVariant, InputDensity } from "@/types/props";

defineSlots<{
  default(): unknown;
}>();

const model = defineModel<unknown>();

const emits = defineEmits<{
  (e: "update:modelValue", value: unknown): void;
}>();

const props = withDefaults(
  defineProps<{
    modelValue?: unknown;
    multiple?: boolean;
    mandatory?: boolean | "force";
    color?: string;
    density?: InputDensity;
    variant?: ButtonVariant;
    divided?: boolean;
    border?: boolean | string | number;
    disabled?: boolean;
    spaceBetween?: boolean;
  }>(),
  {
    modelValue: undefined,
    multiple: false,
    mandatory: false,
    color: "primary",
    density: "compact",
    variant: "flat",
    divided: false,
    border: false,
    disabled: false,
    spaceBetween: false,
  },
);
</script>

<template>
  <v-btn-toggle
    v-model="model"
    :border="props.border"
    :class="{ 'd-flex w-100 justify-space-between': props.spaceBetween }"
    :color="props.color"
    :density="props.density"
    :disabled="props.disabled"
    :divided="props.divided"
    :mandatory="props.mandatory"
    :multiple="props.multiple"
    :variant="props.variant"
  >
    <slot />
  </v-btn-toggle>
</template>
